import { createSlice } from "@reduxjs/toolkit";

const schoolProfileSlice = createSlice({
  name: "schoolProfileSlice",
  initialState: {
    schoolProfileData : {},
    loading: false,
    error: null,
  },
  reducers: {
    getSchoolProfileRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getSchoolProfileSuccess: (state, action) => {
      state.loading = false;
      state.schoolProfileData = action.payload;
    },
    getSchoolProfileFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearSchoolProfile: (state) => {
      state.schoolProfileData = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  getSchoolProfileRequest,
  getSchoolProfileSuccess,
  getSchoolProfileFailure,
  clearSchoolProfile,
} = schoolProfileSlice.actions;

export default schoolProfileSlice.reducer;
